import { useFormikContext } from 'formik';
import Cleave from 'cleave.js/react';
import { useTranslation } from 'react-i18next';
import { Col, InputGroup, InputGroupText, Label } from 'reactstrap';
import ToggleSwitch from 'Components/pos2u/Buttons/ToggleSwitch';
import { useSettings } from 'pages/SettingsV2/SettingsContext';
import { SettingsFormValues } from 'pages/SettingsV2/settingsTypes';
import SettingsV2SectionCard from 'pages/SettingsV2/SettingsV2SectionCard';
import { TOGGLE_SWITCH_SIZE } from 'pages/SettingsV2/SettingsConstants';

const ServiceChargeSectionV2 = () => {
  const { t } = useTranslation();
  const {
    fieldErrors,
    clearFieldError,
    validateField,
    isSectionAccessible,
    getSectionRestrictionNotice,
  } = useSettings();
  const { values, setFieldValue } = useFormikContext<SettingsFormValues>();
  const { isActive, percent, vat } = values.serviceCharge;
  const accessible = isSectionAccessible('serviceCharge');
  const notice = getSectionRestrictionNotice('serviceCharge');

  return (
    <SettingsV2SectionCard
      sectionKey="serviceCharge"
      title={t('Service Charge Settings')}
      icon="ri-service-line"
      disabled={!accessible}
      notice={notice}
      headerActions={
        <ToggleSwitch
          id="service-charge-v2-active"
          checked={isActive}
          label={t('Enabled')}
          size={TOGGLE_SWITCH_SIZE}
          disabled={!accessible}
          wrapperClassName="flex-nowrap flex-shrink-0"
          onChange={(e) => {
            setFieldValue('serviceCharge.isActive', e.target.checked);
            clearFieldError('serviceCharge.percent');
            clearFieldError('serviceCharge.vat');
          }}
        />
      }
    >
      <div className="mb-3 row">
        <Label
          htmlFor="service-charge-v2-percent"
          className="col-sm-3 col-form-label"
        >
          {t('Service Charge Rate')}
        </Label>
        <Col sm={9}>
          <InputGroup>
            <Cleave
              id="service-charge-v2-percent"
              className="form-control"
              disabled={!isActive}
              value={String(percent ?? '')}
              options={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 3,
                numeralPositiveOnly: true,
                numeralThousandsGroupStyle: 'thousand',
              }}
              onChange={(e: any) => {
                setFieldValue(
                  'serviceCharge.percent',
                  Number(e.target.rawValue || 0)
                );
                clearFieldError('serviceCharge.percent');
              }}
              onBlur={() => validateField('serviceCharge.percent')}
            />
            <InputGroupText>%</InputGroupText>
          </InputGroup>
          {fieldErrors['serviceCharge.percent'] ? (
            <div className="text-danger mt-1 err-txt">
              {t(fieldErrors['serviceCharge.percent'] as string)}
            </div>
          ) : null}
        </Col>
      </div>

      <div className="row">
        <Label
          htmlFor="service-charge-v2-vat"
          className="col-sm-3 col-form-label"
        >
          {t('VAT')}
        </Label>
        <Col sm={9}>
          <InputGroup>
            <Cleave
              id="service-charge-v2-vat"
              className="form-control"
              disabled={!isActive}
              value={String(vat ?? '')}
              options={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 3,
                numeralPositiveOnly: true,
                numeralThousandsGroupStyle: 'thousand',
              }}
              onChange={(e: any) => {
                setFieldValue('serviceCharge.vat', Number(e.target.rawValue || 0));
                clearFieldError('serviceCharge.vat');
              }}
              onBlur={() => validateField('serviceCharge.vat')}
            />
            <InputGroupText>%</InputGroupText>
          </InputGroup>
          {fieldErrors['serviceCharge.vat'] ? (
            <div className="text-danger mt-1 err-txt">
              {t(fieldErrors['serviceCharge.vat'] as string)}
            </div>
          ) : null}
        </Col>
      </div>
    </SettingsV2SectionCard>
  );
};

export default ServiceChargeSectionV2;
